/* MOBILE MENU */
/* =================================== */
jQuery(function($) {
	var navigation = $('#mobile-navigation'),
		button = $('.menu-button', navigation),
		menu = $('.mobile-menu', navigation);

	button.on('click', function(e) {
		button.toggleClass('open');
		menu.toggleClass('open');

		e.preventDefault();
	});

	menu.on('click', function(e) {
		button.toggleClass('open');
		menu.toggleClass('open');

		e.preventDefault();
	});

	menu.find('ul').on('click', function(e) {
		e.stopImmediatePropagation();
	});
});


/* MEDIA SLIDER */
/* =================================== */
jQuery(function($) {
	var sliders = $('.slider');

		sliders.each(function() {
			var timer;

			var slides = $(this).find('.slides li'),
				pages = $(this).find('.controls .pages li'),
				buttons = $('a', pages);

			var index = 0,
				default_duration = 8000,
				duration = default_duration;

			function showSlide() {
				slides.eq(index).addClass('active');
				pages.eq(index).addClass('active');
				restartVideo();
				resetTimer();
			};
			function hideSlide() {
				slides.eq(index).removeClass('active');
				pages.eq(index).removeClass('active');

				var video = slides.eq(index).find('video')[0];

				if (video) {
					video.pause();
				}
			};

			function prevSlide() {
				hideSlide();

				index = (index == 0) ? slides.length - 1 : index - 1;

				showSlide();
			};
			function nextSlide() {
				hideSlide();

				index = (index == slides.length - 1) ? 0 : index + 1;

				showSlide();
			};
			function selectSlide(x) {
				if (x == index) {
					resetTimer();
					return;
				}

				hideSlide();

				index = x;

				showSlide();
			};
			function updateDuration() {
				var d = slides.eq(index).data('duration');

				if (typeof d != 'undefined' && d != '') {
					duration = d;
				} else {
					duration = default_duration;
				}
			};
			function restartVideo() {
				var video = slides.eq(index).find('video')[0];

				var query = window.matchMedia('all and (max-width: 767px)');

				if(query.matches) return;

				if (video) {
					video.pause();
					video.currentTime = 0;
					video.load();
					video.play();
				}
			};
			function setTimer() {
				updateDuration();
				timer = window.setTimeout(nextSlide, duration);
			};
			function resetTimer() {
				clearTimeout(timer);
				setTimer();
			};
			function startSlideShow() {
				showSlide();
			};


			//if (pages.length > 1) { startSlideShow() }

			startSlideShow();

			buttons.on('click', function(e) {
				var button = $(this),
					x = buttons.index(button);

				selectSlide(x);
				e.preventDefault();
			});
		});
});


/* MEDIA SEARCH FORM */
/* =================================== */
jQuery(function($) {
	$('.search-form').on('submit', function(e) {
		var form = $(this),
			q = $('input[name="q"]');

		var query = $('#query', form),
			tags = $('#tags', form).val().split('+'),
			product_type = $('#product-type, select[name="product-type"], input[name="product-type"]:checked', form),
			product_collection = $('#product-collection', form);

		var str = query.val().trim() + ' product_type:' + product_type.val();

		for (var i = 0; i < tags.length; i++) {
			if (tags[i] != '') str = str + ' tag:' + tags[i];
		}

		if (product_collection.val() != '') {
			str = str + ' tag:' + product_collection.val();
		}

		window.location = '/search?q=' + str;

		e.preventDefault();
	});
});


/* INTERACTIVE PRODUCT GRID */
/* =================================== */
function onMediaLoad(el, callback) {
	el = (el instanceof jQuery) ? el[0] : el;

	if (el.addEventListener) {
    el.addEventListener('load', function (e) { setTimeout(callback, 0); }, false);
  } else if (el.attachEvent) {
    el.addEventListener('load', function (e) { setTimeout(callback, 0); }, false);
  } else {
    el.onload = function(e) { setTimeout(callback, 0); };
  }
	return el;
}

jQuery(function($) {
	$('.grid')
	.on('mouseover', '.grid-item.hover a', function(e) {
		var query = window.matchMedia('all and (max-width: 767px)');

		if (query.matches) return;

		var item = $(this).closest('.grid-item'),
			type = item.hasClass('video') ? 'video' : item.hasClass('photo') ? 'photo' : item.hasClass('audio') ? 'audio' : 'unknown';

		var container = $('<div class="hover-container"></div>'),
			inner = $('<div class="hover-container-inner"></div>');

		var media;

		if (item.has('.hover-container').length) return;

		container.append(inner);

		if (type == 'video')
		{
			var image = $('.image img', item),
				mp4_src = image.attr('data-video-preview-480-mp4'),
				webm_src = image.attr('data-video-preview-480-webm'),
				png_src = image.attr('data-video-preview-480-png');

			var video = $('<video autoplay loop poster="' + png_src + '"></video>');

			var mp4 = $('<source src="' + mp4_src + '" type="video/mp4" >');
			var webm = $('<source src="' + webm_src + '" type="video/webm" >');

			var img = $('<img src="' + png_src + '" class="no-show" />');

			media = img;

			video.append(mp4).append(webm).appendTo(inner.append(img));
		}
		else if (type == 'audio')
		{
			var image = $('.image img', item),
				audio_type = image.attr('data-audio-type'),
				mp3_src = image.attr('data-audio-preview-mp3'),
				png_src = image.attr('data-audio-preview-png');

			var img = $('<img src="' + png_src + '" />');

			var waveform = $('<div class="audio-waveform-wrapper">'),
				indicator = $('<div class="progress-indicator">'),
				background = $('<div class="progress-background"></div>');

			var audio = $('<audio autoplay loop></audio>');

			var mp3 = $('<source src="' + mp3_src + '" type="audio/mpeg" >');

			function animateWaveform() {
				var progress = this.currentTime / this.duration;

				var left = (waveform.width() * progress);

				indicator.css({ 'left': left });
				background.css({ 'width': left });
			}

			media = img;

			waveform.addClass(audio_type).append(indicator).append(img).append(background).appendTo(inner);
			audio.append(mp3).appendTo(inner).on('timeupdate', animateWaveform);
		}
		else if (type == 'photo')
		{
			var image = $('.image img', item),
				src = image.attr('data-photo-preview');

			var img = $('<img src="' +src+ '" />');

			media = img;

			img.appendTo(inner);
		}

		function adjustContainer() {
			var doc = document.documentElement,
				offset = container.offset();

			var view = {};

			view.width = window.innerWidth;
			view.height = window.innerHeight;

			view.top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
			view.left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
			view.right = view.left + view.width;
			view.bottom = view.top + view.height;

			var box = {};

			box.width = container.width();
			box.height = container.height();

			box.top = offset.top;
			box.left = offset.left;
			box.right = box.left + box.width;
			box.bottom = box.top + box.height;

			if (box.right > view.right) container.removeClass('right').addClass('left');
			if ((box.left - box.width) < view.left) container.removeClass('left').addClass('right');

			container.addClass('visible');
		};

		container.appendTo(item);
		
		onMediaLoad(media, adjustContainer);
	})
	.on('mouseout', '.grid-item', function(e) {
		var item = $(this);

		if (item.has('.hover-container').length) {
			var video = $('.hover-container video')[0];

			if (video) {
				video.pause();
				video.src = "";
				video.load();
			}

			var audio = $('.hover-container audio')[0];

			if (audio) {
				audio.pause();
				audio.src = "";
				audio.load();
			}

			item.find('.hover-container').remove();
		}
	});

	$('video.hover-play')
	.on('mouseover', function(e) {
		var video = $(this)[0];

		video.play();
	})
	.on('mouseout', function(e) {
		var video = $(this)[0];

		video.pause();
	});

});



/* ANIMATED AUDIO WAVEFORMS */
/* =================================== */
jQuery(function($) {
	$('.audio-player-group').each(function() {
		var wrapper = $(this);

		var container = $('.audio-waveform-wrapper', wrapper),
			player = $('.audio-player', wrapper),
			indicator = $('.progress-indicator', container),
			background = $('.progress-background', container);

		player.on('timeupdate', function() {
			var progress = this.currentTime / this.duration;

			var left = (container.width() * progress);

			indicator.css({ 'left': left });
			background.css({ 'width': left });
		});
	});
});



/* SIDEBAR FILTERS */
/* =================================== */
jQuery(function($) {
	$('.collection-sidebar .filters > li > a').on('click', function(e) {
		var anchor = $(this);

		anchor.toggleClass('active');

		e.preventDefault();
	});
});


/* PRODUCT MASONRY GRID */
/* =================================== */
jQuery(function($) {
	$('.collection-grid .grid').each(function() {
		var grid = $(this);

		grid.on('layoutComplete', function( event, items ) {
			$('img', grid).unveil(200);
		});

		grid.masonry({
			gutter: 0,
			columnWidth: '.grid-item',
			itemSelector: '.grid-item'
		});



	});
});


/* PRODUCT IMAGE ZOOM */
/* =================================== */
jQuery(function($) {
	$('.image-zoom').each(function() {
		var el = $(this),
			url = el.find('img').attr('data-zoom-url');

		el.zoom({
			url:url,
			on:'click',
			touch:false,
			magnify:1,
			onZoomIn: function() {
				$(this).closest('.image-zoom').addClass('zoom');
			},
			onZoomOut: function() {
				$(this).closest('.image-zoom').removeClass('zoom');
			}
		});
	})
});


/* EMBED IMAGE SNIPPET */
/* =================================== */
jQuery(function($) {
	$('#embed-media').on('click', function(e) {
		$('#embed-snippet').slideToggle('fast', function() {
			$(this).find('textarea').focus();
		});

		e.preventDefault();
	});
});


/* MOBILE PRODUCT FORM */
/* =================================== */
jQuery(function($) {
	$('.variants li label').click(function(e) {
		$(this).closest('.variants').toggleClass('active');
	});
});


/* EMBED IMAGE SNIPPET */
/* =================================== */
jQuery(function($) {
	$('.keyword-list .label').on('click', function(e) {
		var label = $(this);

		var container = label.closest('.keyword-list');
		var list = $('.list', container);

		label.toggleClass('visible');
		list.toggleClass('visible');

		e.preventDefault();
	});
});

/* PSEUDO SELECT ELEMENTS */
/* =================================== */
jQuery(function($) {
	$('.pseudo-select label').click(function(e) {
		$(this).closest('.pseudo-select').toggleClass('active');
	});
});


/* SHARE PRODUCT */
/* =================================== */
jQuery(function($) {
	function popupWindow(url, name, w, h) {
		var width = w,
			height = h,
			left = (($(window).width() - width) / 2),
			top = (($(window).height() - height) / 2),
			specs = 'status=1,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left;

		window.open(url, name, specs);
	};

	$('.share-buttons a:not(.email)').on('click', function(e) {
		popupWindow(this.href, 'social', 575, 300);
		e.preventDefault();
	});
});


/* MODAL POPUP FORMS */
/* =================================== */
jQuery(function($) {
	$('.popup-form').on('click', function(e) {
		var a = $(this),
			modal = $('<div id="modal">');

		function loadForm(options) {

			// Load Modal Form
			if (typeof options == 'string') {
				$.get(options, function(data) {
					updateModal(data);
				});
			} else {
				updateModal(options);
			}

			function updateModal(data) {
				var wrapper = $(data).find('.form-wrapper');

				wrapper.find('a.switch-form').on('click', function(e) {
					loadForm($(this).attr('href'));
					e.preventDefault();
				});

				wrapper.find('a.show-password-form').on('click', function(e) {
					var customer_form = wrapper.find('.customer-form'),
						password_form = wrapper.find('.recover-email-form'),
						title = wrapper.closest('.modal-content').find('.modal-title');

					customer_form.hide();
					password_form.show();

					title.html(password_form.data('form-title'));

					e.preventDefault();
				});

				wrapper.find('a.hide-password-form').on('click', function(e) {
					var customer_form = wrapper.find('.customer-form'),
						password_form = wrapper.find('.recover-email-form'),
						title = wrapper.closest('.modal-content').find('.modal-title');

					customer_form.show();
					password_form.hide();

					title.html(customer_form.data('form-title'));

					e.preventDefault();
				});

				modal.find('.modal-content').remove();

				$('<div class="modal-content">').on('click', stopPropagation)
					.append($('<a class="modal-close" href="#">&times;</a>').on('click', hideModal))
					.append($('<div class="modal-title">').html(wrapper.data('form-title')))
					.append(wrapper)
					.appendTo(modal);

				showModal();
			};

		};

		function showModal() {
			var has_modal = $('body').find(modal).length;

			if (has_modal) {
				modal.fadeIn('fast');
			} else {
				modal.hide().appendTo('body').fadeIn('fast');
			}
		};

		function hideModal(e) {
			modal.fadeOut('fast', function() {
				modal.remove();
			});

			e.preventDefault();
		};

		function stopPropagation(e) {
			e.stopImmediatePropagation();
		};

		// Bind Modal Events
		modal.on('click', hideModal);


		// Load Modal Form
		loadForm(a.attr('href'));

		e.preventDefault();
	});
});


/* Password Recovery Form */
/* =================================== */
jQuery(function($) {
	function showRecoverPasswordForm(e) {
		var el = $(this),
			wrapper = el.closest('.form-wrapper');


		$('.recover-email-form', wrapper).show();
		$('.customer-form', wrapper).hide();

		e.preventDefault();
	}

	function hideRecoverPasswordForm(e) {
		var el = $(this),
			wrapper = el.closest('.form-wrapper');


		$('.recover-email-form', wrapper).hide();
		$('.customer-form', wrapper).show();

		e.preventDefault();
	}

	function loadRecoverPasswordForm() {
		var el = $('body'),
			wrapper = el.find('.form-wrapper');


		$('.recover-email-form', wrapper).show();
		$('.customer-form', wrapper).hide();
	}

	$('.show-password-form').on('click', showRecoverPasswordForm);
	$('.hide-password-form').on('click', hideRecoverPasswordForm);

	if (window.location.hash == '#recover') { loadRecoverPasswordForm() }
});



/* PRELOAD IMAGES */
/* =================================== */
var preload_images = new Array();

function preload() {
	for (var i = 0; i < preload.arguments.length; i++) {
		preload_images[i] = new Image();
		preload_images[i].src = preload.arguments[i];
	}
}



/* CUSTOMER ACCOUNT PANELS */
/* =================================== */
jQuery(function($) {

	$('.account-links a').on('click', function(e) {
		var target = $(this).attr('href'),
			links = $('.account-links a'),
			panels = $('.account-content .content-section');

		links.removeClass('active');
		$(this).addClass('active');

		panels.hide();
		$(target).show();

		e.preventDefault();
	});

	if (window.location.hash) {
		$('.account-links a[href="' +window.location.hash+ '"]').trigger('click');
	}


	$('#apply-changes').on('click', function(e) {
		var section = $(this).closest('.content-section'),
			forms = $('form', section);

		forms.each(function() {
			$(this).submit();
		});

		e.preventDefault();
	});

});
